import { Dispatch } from "react";
import { Notification } from "@Types/notifications";
import {
  addNotificationByCode,
  AddNotificationByCodeAction,
} from "./actions/addNotificationByCode";
import { removeNotification, RemoveNotificationAction } from "./actions/removeNotification";

export interface InitialNotificationsState {
  notifications: Notification[];
}
export type NotificationsState = Required<InitialNotificationsState>;

export type NotificationAction = AddNotificationByCodeAction | RemoveNotificationAction;

export const notificationsReducer: (
  state: NotificationsState,
  action: NotificationAction
) => NotificationsState = (state, action) => {
  let nextState: NotificationsState;

  switch (action.type) {
    case "addNotificationByCode":
      nextState = addNotificationByCode(state, action);
      break;
    case "removeNotification":
      nextState = removeNotification(state, action);
      break;
    default:
      const exhaustiveCheck: never = action;
      throw new Error(`Unsupported type ${(exhaustiveCheck as { type: string }).type}`);
  }

  return nextState;
};

export type DispatchNotificationAction = Dispatch<NotificationAction>;
